import { differenceInYears, parseISO } from 'date-fns/fp';
import { Goal, Gender, ActivityLevel, DietType } from '@calo/types';
import { MACROS_DISTRIBUTION } from './constants';
class MacrosService {
    getCal(data) {
        const { dob, gender, weight, height, activityLevel, goal } = data;
        const age = differenceInYears(parseISO(dob))(Date.now());
        let bmr = this.getBMR(age, gender, weight, height);
        switch (activityLevel) {
            case ActivityLevel.level1:
                bmr = bmr * 1.2;
                break;
            case ActivityLevel.level2:
                bmr = bmr * 1.375;
                break;
            case ActivityLevel.level3:
                bmr = bmr * 1.55;
                break;
            case ActivityLevel.level4:
                bmr = bmr * 1.725;
                break;
            case ActivityLevel.level5:
                bmr = bmr * 1.9;
                break;
        }
        bmr = Math.round(bmr);
        switch (goal) {
            case Goal.loseWeight:
                return bmr - 500;
            case Goal.gainWeight:
                return bmr + 500;
            default:
                return bmr;
        }
    }
    getMacrosBag(cal, diet) {
        let calCap = Math.max(1000, Math.round(cal));
        switch (diet) {
            case DietType.vegetarian:
                return {
                    cal: calCap,
                    carbs: {
                        min: Math.round(calCap * 0.45 / 4),
                        max: Math.round(calCap * 0.55 / 4),
                    },
                    protein: {
                        min: Math.round(calCap * 0.15 / 4),
                        max: Math.round(calCap * 0.25 / 4),
                    },
                    fat: {
                        min: Math.round(calCap * 0.2 / 9),
                        max: Math.round(calCap * 0.3 / 9),
                    },
                };
            case DietType.lowCarb:
                calCap = Math.max(1200, Math.round(cal));
                return {
                    cal: calCap,
                    carbs: {
                        min: Math.round(calCap * 0.1 / 4),
                        max: Math.round(calCap * 0.2 / 4),
                    },
                    protein: {
                        min: Math.round(calCap * 0.25 / 4),
                        max: Math.round(calCap * 0.35 / 4),
                    },
                    fat: {
                        min: Math.round(calCap * 0.4 / 9),
                        max: Math.round(calCap * 0.5 / 9),
                    },
                };
            default:
                return {
                    cal: calCap,
                    carbs: {
                        min: Math.round(calCap * 0.40 / 4),
                        max: Math.round(calCap * 0.55 / 4),
                    },
                    protein: {
                        min: Math.round(calCap * 0.2 / 4),
                        max: Math.round(calCap * 0.35 / 4),
                    },
                    fat: {
                        min: Math.round(calCap * 0.2 / 9),
                        max: Math.round(calCap * 0.3 / 9),
                    },
                };
        }
    }
    getCustomMacrosBag(cal, macrosPreset) {
        const calCap = Math.max(1000, Math.round(cal));
        return {
            cal: calCap,
            carbs: {
                min: Math.round(calCap * MACROS_DISTRIBUTION[macrosPreset].carbs.min / 4),
                max: Math.round(calCap * MACROS_DISTRIBUTION[macrosPreset].carbs.max / 4),
            },
            protein: {
                min: Math.round(calCap * MACROS_DISTRIBUTION[macrosPreset].protein.min / 4),
                max: Math.round(calCap * MACROS_DISTRIBUTION[macrosPreset].protein.max / 4),
            },
            fat: {
                min: Math.round(calCap * MACROS_DISTRIBUTION[macrosPreset].fat.min / 9),
                max: Math.round(calCap * MACROS_DISTRIBUTION[macrosPreset].fat.max / 9),
            },
        };
    }
    getBMR(age, gender, weight, height) {
        const constant = gender === Gender.female ? -161 : 5;
        let bmr = (10 * weight) + (6.25 * height) - (5 * age) + constant;
        return bmr;
    }
}
export default new MacrosService();
